import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { DadosUsuarioService } from '@services/dados-usuario.service';
import { AlertDetalheRotaComponent } from '../alert-detalhe-rota/alert-detalhe-rota.component';
import { NgClass } from '@angular/common';
import { AppDatePipe } from '../../../pipes/app-date.pipe';

@Component({
    selector: 'app-alert-refazer-rota',
    templateUrl: './alert-refazer-rota.component.html',
    styleUrls: ['./alert-refazer-rota.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [AlertDetalheRotaComponent, NgClass, AppDatePipe]
})
export class AlertRefazerRotaComponent {

  @Input() dadosRoteirizacao: any;
  @Output() alertRefazerRotaFechou = new EventEmitter();
  @Input() idUsuario: any;
  public showAlertRota: boolean = false;
  public dadosDetalheRota: any = null;
  public idEmpresa: any;

  constructor(
    private readonly dadosUsuarioService: DadosUsuarioService
  ) { }

  fecharAlertRefazerRota(acao: string) {
    this.alertRefazerRotaFechou.emit(acao);
  }

  fecharAlertFatura(evento: any) { 
    this.showAlertRota = false;
    this.dadosDetalheRota = null;
  }

  printRotaInteligente() {

    this.idEmpresa = localStorage.idEmpresaLogada;

    this.showAlertRota = true;

this.dadosUsuarioService.getHtmlRota(this.idEmpresa, this.dadosRoteirizacao.idRoteirizacao, this.idUsuario)
    .subscribe({
      next: (response: any) => {
        const html = response.response;
        this.dadosDetalheRota = html.replace('.', '').replace('\\', '');
      },
      error: (erro: any) => {
        console.error(erro);
      }
    });
  }
}
